// Which invoice actions the "···" sheet may offer at ≤880px (mobile overhaul
// Phase C §8.2 G). Mirrors the desktop header's own conditionals in
// pages/InvoiceDetail.tsx exactly, so mobile never offers something desktop
// hides:
//
//   Download PDF       always
//   Copy public link   status !== 'void'
//   Send invoice       draft | sent | overdue   (`actionable`)
//   Send reminder      sent | overdue
//   Void               `actionable`
//   Record payment     `actionable`
//   Trash              always (the rail's TrashAction is unconditional)
//
// The status passed in is the *display* status (Finance's displayStatus —
// a sent invoice past its due date reads as overdue), which is what the
// desktop header branches on too.

import type { InvoiceStatus } from '../../shared/types';

export type InvoiceActionKey =
  | 'download-pdf'
  | 'record-payment'
  | 'send-reminder'
  | 'send-invoice'
  | 'copy-link'
  | 'void'
  | 'trash';

/** Sheet order, mockup §8.2 G — the list below is filtered, never reordered. */
const ORDER: InvoiceActionKey[] = [
  'download-pdf',
  'record-payment',
  'send-reminder',
  'send-invoice',
  'copy-link',
  'void',
  'trash',
];

export function invoiceActionsFor(status: InvoiceStatus): InvoiceActionKey[] {
  const actionable = status === 'draft' || status === 'sent' || status === 'overdue';
  const allowed: Record<InvoiceActionKey, boolean> = {
    'download-pdf': true,
    'record-payment': actionable,
    'send-reminder': status === 'sent' || status === 'overdue',
    'send-invoice': actionable,
    'copy-link': status !== 'void',
    void: actionable,
    trash: true,
  };
  return ORDER.filter((key) => allowed[key]);
}
